import React, {useEffect, useState} from 'react';
import Header from "@/view/layout/Header";
import HeaderSpacer from "@/view/layout/HeaderSpacer";
import Main from "@/view/main/component/Main"


const MainView: React.FC = (): JSX.Element => {
    const [headType, setHeadType] = useState(0)
    const [response, setResponse] = useState(false)

    return (<>
        {
            headType === 0?
                <Header leftIcon={'menu-w'}/>
            :
                <Header leftIcon={'menu-b'}/>
        }
        { headType === 0?
                <HeaderSpacer className='bg-cl-black'/>
            :
                <HeaderSpacer className='bg-cl-gray-7'/>
        }
        {
            response ?
                <div><Main/></div>
                :
                <div><Main/></div>
        }

    </>)
}

export default MainView;